export const notification_type_enum = [
  "game_new",
  "game_updated",
];
